import React from 'react'
import Popup from 'reactjs-popup'
import { eFormButtonsContainer } from '../common/cssclasses'
import NewActionButton from './ActionButtons/NewActionButton'
import DraftBtn from './servicesButtons/DraftBtn'
import SubmitServiceBtn from './servicesButtons/SubmitServiceBtn'
import { useTranslate } from './TranslationText'

export default function CustomPopUp({ trigger, isBid = false, title = "", content = "", onClick = "", btnText = "", disabled = false, isShowEventCard = false, ...props }) {
    const { translate } = useTranslate();

    async function doOnClick(e, close) {
        if (disabled) return;

        const result = await onClick(e);

        if (result === false) return;

        close();
    }


    return (
        <Popup
            trigger={trigger}
            modal
            closeOnEscape={isShowEventCard}
            closeOnDocumentClick={isShowEventCard}
            lockScroll={true}
            contentStyle={isShowEventCard?{}:{ width: '100%', maxWidth: '80%', minWidth: '300px', background: 'rgba(0,0,0,0)' }}
            overlayStyle={{ background: 'rgba(0,0,0,0.7)', zIndex: 5000 }}

            {...props}
        >
            {(close) =>
            (
                <>{isShowEventCard ?
                    content :
                    <>
                        <div className='container bg-white border-success p-4' style={{ maxWidth: 1300, borderRadius: 25 }} >
                            {!!title &&
                                < h4 className='fw-bold'>
                                    {title}
                                </h4>
                            }
                            {!!content &&
                                <div className='popUpElemnts mb-main row justify-content-center' style={isBid ? { minHeight: 'unset', overflow: 'hidden' } : {}}>
                                    {content}
                                </div>
                            }
                            <div className={eFormButtonsContainer}>
                                <DraftBtn
                                    onClick={close}
                                    text={translate('web.close', 'Close')}
                                />
                                {!!onClick &&
                                    <SubmitServiceBtn text={btnText} key={'submit'} onClick={(e) => doOnClick(e, close)} disabled={disabled} />
                                }
                            </div>
                        </div>
                    </>}

                </>
            )

            }
        </Popup >
    )
}
